module.exports = __webpack_public_path__ + "static/assets/fb54bedbd5f2f1bd7dc9bd27a26992b5.gif";